import { Component, OnInit } from '@angular/core';
import {ExcursionServiceService} from '../../service/excursion-service.service'
import { Chart } from 'chart.js';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DataServiceService } from 'src/app/service/data-service.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ElementRef, ViewChildren,ViewChild } from '@angular/core';
import { Calendar } from 'primeng/calendar';
// import moment from 'moment';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  chart: any;
  @ViewChild('theCalendarreq') public calendar!: Calendar;
critical_list=[{'id':'','value':'Show All'},{'id':'1','value':'CRITICAL'},{'id':'0','value':'NORMAL'}]
  supplier_chart:any;
  chartone:any;
  d = new Date();
  noofDays:number = 0;

  registerForm=new FormGroup({
    request_date_from: new FormControl('', [Validators.required, Validators.minLength(3)]),
    request_date_to: new FormControl('', [Validators.required, Validators.email]),
    transfer_date_from: new FormControl(new Date(), Validators.required),
    transfer_date_to: new FormControl(new Date(), Validators.required),
    priority:new FormControl('',Validators.required),
    criticality:new FormControl('',Validators.required)
  });
  constructor(private excursionServiceService:ExcursionServiceService,private toastrService: ToastrService,private datePipe: DatePipe,
    private data_service:DataServiceService,private router: Router) { }
  selectedCar: number | undefined;
  team_member_count:any=[];
  supplier_count:any=[];
  prioritylist:any=[{'priority_id':0,'priority_name':'Show All'}];
  supplier_date_set={'assign_count':0,'pending_count':0,'total_connt':0,'completd_count':0,'cancelled_count':0,'reject_count':0}
  dashboar_data:any=[]

  doughnutChartLabels: string[] = ['US1', 'UK1', 'EU1', 'SI1'];
  doughnutChartData: number[] = [26, 50, 50];
  chartOptions = {
    responsive: false,

  };
  get f() { return this.registerForm.controls; }
  reset(){
    this.registerForm.patchValue({
      request_date_from: '',
    request_date_to: '',
    transfer_date_from: new Date(),
    transfer_date_to: new Date(),
    priority:'',
    criticality:''
    })

  }
  registerFormSubmit() {
    
    ////console.log(this.excursionServiceService.compareDates(this.registerForm.value['request_date_to'],this.registerForm.value['request_date_from']))
    // //console.log(new Date(this.registerForm.value['request_date_to'].toDateString()))
//console.log(this.registerForm.value)
if(this.registerForm.value['request_date_to']!=''&& this.registerForm.value['request_date_to']!=null){
  if(this.registerForm.value['request_date_from']=='' || this.registerForm.value['request_date_from']==null){
    this.toastrService.error('Invalid date', 'Title Error!',{closeButton:true, timeOut: 3000});
    return
  }
  this.registerForm.value['request_date_to']=new Date(this.registerForm.value['request_date_to'])
  if (this.excursionServiceService.compareDates(this.registerForm.value['request_date_to'],this.registerForm.value['request_date_from'])==-1){
    this.toastrService.error('Invalid date', 'Title Error!',{closeButton:true, timeOut: 3000});
    return
  }
  this.registerForm.value['request_date_to']=new Date(this.registerForm.value['request_date_to'].getTime() - this.registerForm.value['request_date_to'].getTimezoneOffset()*60000).toISOString();
}

if(this.registerForm.value['transfer_date_to']!='' && this.registerForm.value['transfer_date_to']!=null)
{
  if(this.registerForm.value['transfer_date_from']=='' || this.registerForm.value['transfer_date_from']==null){
    this.toastrService.error('Invalid date', 'Title Error!',{closeButton:true, timeOut: 3000});
    return
  }
  this.registerForm.value['transfer_date_to']=new Date(this.registerForm.value['transfer_date_to'])
  if (this.excursionServiceService.compareDates(this.registerForm.value['transfer_date_to'],this.registerForm.value['transfer_date_from'])==-1)
  {
    this.toastrService.error('Invalid date', 'Title Error!',{closeButton:true, timeOut: 3000});
    return
  }
  this.registerForm.value['transfer_date_to']=new Date(this.registerForm.value['transfer_date_to'].getTime() - this.registerForm.value['transfer_date_to'].getTimezoneOffset()*60000).toISOString();
}
if(this.registerForm.value['request_date_from']!='' && this.registerForm.value['request_date_from']!=null){
  this.registerForm.value['request_date_from']=new Date(this.registerForm.value['request_date_from'])
  this.registerForm.value['request_date_from']=new Date(this.registerForm.value['request_date_from'].getTime() - this.registerForm.value['request_date_from'].getTimezoneOffset()*60000).toISOString();
}
if(this.registerForm.value['transfer_date_from']!='' && this.registerForm.value['transfer_date_from']!=null){
  this.registerForm.value['transfer_date_from']=new Date(this.registerForm.value['transfer_date_from'])
  this.registerForm.value['transfer_date_from']=new Date(this.registerForm.value['transfer_date_from'].getTime() - this.registerForm.value['transfer_date_from'].getTimezoneOffset()*60000).toISOString();
}


  //   if (this.registerForm.value['request_date_to']!=''&& this.registerForm.value['request_date_to']!=null){
    
  //   // else{
  //   //   this.registerForm.patchValue({
  //   //     request_date_to:new Date(this.registerForm.value['request_date_to']),
  //   //     request_date_from:new Date(this.registerForm.value['request_date_to'])
  //   //   });

  //   // }

  // }
   
    // else{
    //   this.registerForm.patchValue({
    //     transfer_date_to:new Date(this.registerForm.value['transfer_date_to']),
    //     transfer_date_from:new Date(this.registerForm.value['transfer_date_from'])
    //   });

    // }

  
    if (this.chart!=undefined){
      this.chart.destroy()
    }
    if (this.supplier_chart!=undefined){
      this.supplier_chart.destroy()
    }
    this.loaddashboard(this.registerForm.value)
  }
  changedate(event:any,str:any){
    this.registerForm.value[str]=new Date(event.getTime() - event.getTimezoneOffset()*60000).toISOString();
    // this.registerForm.patchValue({str:new Date(event.getTime() - event.getTimezoneOffset()*60000).toISOString()})
  }
  resetFormSubmit() {

    this.loaddashboard(this.registerForm.value)
  }
  clicktoload(data:any,status:any){
    this.data_service.changeMessage({"form":data,"status":status})
    this.router.navigate(['/webqnex/excursion']);
  }
  autofocus(){
    window.setTimeout(() => {
      // console.log('setting focus now');
      this.calendar.inputfieldViewChild.nativeElement.focus();
      this.calendar.toggle()
  }, 10);
  }
  ngOnInit(): void {
    // this.toastrService.success('Message Success!', 'Title Success!',{closeButton:true, timeOut: 3000});
    
    const data={}
    this.noofDays = Number(localStorage.getItem('noofdays'));
    //console.log(this.noofDays);
    const currentDate = new Date();
    if(this.noofDays != 0){
      currentDate.setDate(currentDate.getDate() + (-1 * this.noofDays));
    }
    this.registerForm.patchValue({
      transfer_date_from: currentDate,
    });
    //console.log(this.registerForm.value);
    this.excursionServiceService.prioritylist().subscribe(r=>{
      this.loaddashboard(this.registerForm.value)
      if (r['result']==1){
          this.prioritylist=this.prioritylist.concat(r['data']);
      }
    });

  }
  loaddashboard(data: {}){
    this.excursionServiceService.getdashboard_list(data).subscribe(r=>{
      if (r['result']==1){
      this.dashboar_data=r['data'][0]['dashboard_count']

      this.team_member_count=r['data'][0]['team_member_count']


      this.supplier_count=r['data'][0]['supplier_count']
      ////console.log('test')
      ////console.log(this.team_member_count)

      this.supplier_count.forEach((res: any)=> {

        this.supplier_date_set['assign_count']=this.supplier_date_set['assign_count']+res['assigned_count']
        this.supplier_date_set['completd_count']=this.supplier_date_set['completd_count']+res['completed_count']
        this.supplier_date_set['reject_count']=this.supplier_date_set['reject_count']+res['rejected_count']
        this.supplier_date_set['cancelled_count']=this.supplier_date_set['cancelled_count']+res['cancelled_count']
        this.supplier_date_set['total_connt']=this.supplier_date_set['assign_count']+this.supplier_date_set['completd_count']+this.supplier_date_set['reject_count']+this.supplier_date_set['cancelled_count']

        ////console.log(this.supplier_date_set)
    });
    // if (this.team_member_count==undefined ){
    // this.team_member_count.push({'assigned_count':0,'pending_count':0,'s_total_count':0,'completed_count':0,'cancelled_count':0,'rejected_count':0})
    // }

    if (this.team_member_count!=undefined ){
    this.chart = new Chart("pieChart", {
      type: 'pie', //this denotes tha type of chart

      data: {// values on X-Axis
        labels: ['Assigned', 'Completed', 'Pending', 'Cancelled','Rejected'],
	       datasets: [{
    label: this.team_member_count['UserName'],
    data: [(this.team_member_count['assigned_count']/this.team_member_count['s_total_count'])*100, (this.team_member_count['completed_count']/this.team_member_count['s_total_count'])*100, (this.team_member_count['pending_count']/this.team_member_count['s_total_count'])*100, (this.team_member_count['cancelled_count']/this.team_member_count['s_total_count'])*100,(this.team_member_count['rejected_count']/this.team_member_count['s_total_count'])*100],
    backgroundColor: [

      '#00bcd4',
      '#1ab394 ',
			'#23c6c8',
      '#a71b29',
      '#ed5565',
    ],
    hoverOffset: 4
  }],
      },
      options: {
        responsive:true,

        aspectRatio:2,
        plugins: {
          title: {
              display: true,
              text: 'Team Member Status',
              color:'#9e9e9e',
              font: {
                size: 18
            }
          },
          legend: {
            position: 'bottom',
            display: true,
            align: 'center'}
        //   subtitle: {
        //     display: true,
        //     text: ['Assigned', 'completed', 'pending', 'cancelled','Rejected'],
        //     color:'rgb(186 186 186)',
        //   position:'top',
        //   align:'start'

        // }
      }
      },


    });
  }
  else{
    if (this.chart!=undefined){
    this.chart.destroy()}
  }
  if (this.supplier_count.length!=0){
    this.supplier_chart = new Chart("pieChart_supplier", {
      type: 'pie', //this denotes tha type of chart

      data: {// values on X-Axis
        labels: ['Assigned', 'Completed', 'Cancelled','Rejected'],
	       datasets: [{
    label: 'My First Dataset',
    data: [(this.supplier_date_set['assign_count']/this.supplier_date_set['total_connt'])*100, (this.supplier_date_set['completd_count']/this.supplier_date_set['total_connt'])*100,(this.supplier_date_set['cancelled_count']/this.supplier_date_set['total_connt'])*100,(this.supplier_date_set['reject_count']/this.supplier_date_set['total_connt'])*100],
    backgroundColor: [
      '#00bcd4',
      '#1ab394 ',

      '#a71b29',
      '#ed5565',
    ],
    hoverOffset: 4
  }],
      },
      options: {
        aspectRatio:2, plugins: {
          title: {
              display: true,
              text: 'Service Provider Status',
              color:'#9e9e9e',
              font: {
                size: 18
            }
          },
          legend: {
            position: 'bottom',
            display: true,
            align: 'center',
          }
      }
      }

    });

  }else{
    if (this.supplier_chart!=undefined){
    this.supplier_chart.destroy()}
  }

}

    }

      );
  }
  ngAfterViewInit() {
    let ctxone: any = document.getElementById('lineChartone') as HTMLElement;
    var dataone = {
      labels: ['total', 'Assigned', 'completed', 'cancelled','Rejected'],
      datasets: this.supplier_date_set,
    };

    //options
    var options = {
      responsive: true,
      title: {
        display: true,
        position: 'top',
        text: 'Line Graph',
        fontSize: 18,
        fontColor: '#111',
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: '#333',
          fontSize: 16,
        },
      }, scales: {
        y: {
          min: 0,
          max: 100,
          ticks: {
            stepSize: 25
          },
          grid: {
            display: false
          }
        },
        x: {
          grid: {
            color: '##EEEEEE'
          }
        }
      },
    };


    // var chart = new Chart(ctxone, {
    //   type: 'line',
    //   data: dataone,
    //   options: options,
    // });

  }

}
